import React, { createRef } from 'react';
import SectionGroup from 'app/components/general/SectionGroup';
import SchemaForm from 'app/components/general/SchemaForm';

import requestPaymentTypes from 'app/utils/static/requestPaymentTypes';

const formSchema = {
  type: 'object',
  required: ['paymentType',
    'description',
    'amount',
    'dueDate'],
  properties: {
    paymentType: {
      type: ['object', 'null'],
      title: 'Payment Type',
      options: requestPaymentTypes,
      inputType: 'select',
      clearable: true,
      createable: true,
    },
    description: {
      type: 'string',
      title: 'Payment Description (this is what payees will see in their payment request)',
    },
    amount: {
      type: 'string',
      inputType: 'currency',
      title: 'Amount (per payee)',
    },
    dueDate: {
      type: 'array',
      items: {
        type: 'string',
      },
      enableTime: false,
      inputType: 'datetime',
      title: 'Due Date',
    },
  },
};

const uiSchema = {
  paymentType: { 'ui:field': 'select', classNames: 'col' },
  amount: { 'ui:field': 'currency' },
  dueDate: { 'ui:field': 'datetime' },
};

interface IStep1PaymentDetailProps {
  isValid: Function;
  handleChange: Function;
  handleError: Function;
  handleSubmit: Function;
  formData: any;
  errors: any;
  changed: boolean;
  paymentRequests: any;
  originalFormData: any;
}

export default class Step1PaymentDetail extends React.Component<IStep1PaymentDetailProps> {
  static defaultProps: IStep1PaymentDetailProps = {
    formData: undefined,
    changed: false,
    paymentRequests: undefined,
    originalFormData: undefined,
    isValid: undefined,
    handleChange: undefined,
    handleError: undefined,
    handleSubmit: undefined,
    errors: undefined,
  };

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            {this.props.children}
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col">
            <SectionGroup title="Payment Details">
              <div className="form-description">
                You can collect payment from people or teams and have the money
                sent directly to your bank account.
              </div>
              <SchemaForm
                uiSchema={uiSchema}
                schema={formSchema}
                handleChange={this.props.handleChange}
                handleError={this.props.handleError}
                handleSubmit={this.props.handleSubmit}
                formData={this.props.formData}
                errors={this.props.errors}
                liveValidate={false}
                // isValid={this.props.isValid()}
                isLoading={this.props.paymentRequests.isSaving}
                hasSaved={this.props.paymentRequests.hasSaved}
                hasFailed={this.props.paymentRequests.hasFailed}
                originalFormData={this.props.originalFormData}
                buttonText="Next"
              />
            </SectionGroup>
          </div>
        </div>
      </div>
    );
  }
}
